import { useAuth } from '@/app/context';
import { type SubMenuItem } from '@/shared/constants';
import { useRequirePermissions } from '@/shared/hooks';
import { Link, useRouterState } from '@tanstack/react-router';
import { isMenuPathActive } from './menu-active.util';

interface SidebarSubMenuItemProps {
  item: SubMenuItem;
  onMenuClick: () => void;
}

export function SidebarSubMenuItem({
  item,
  onMenuClick,
}: SidebarSubMenuItemProps) {
  const permissions = item.permissions ?? [];
  const { hasPermission, isChecking } = useRequirePermissions({ permissions });
  const { groups: userGroups } = useAuth();

  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;
  const isActive = isMenuPathActive(currentPath, item.id);

  if (permissions.length > 0) {
    if (isChecking) {
      return null;
    }
    if (!hasPermission) {
      return null;
    }
  }

  if (item.groups && item.groups.length > 0) {
    if (!userGroups?.some(g => item.groups!.includes(g))) {
      return null;
    }
  }

  const Icon = item.icon;

  return (
    <Link
      to={item.id}
      data-active={isActive ? 'true' : undefined}
      onClick={onMenuClick}
      className={`
        relative flex h-9 w-full items-center gap-3 rounded-md px-3 text-sm transition-all duration-300 ease-in-out
        ${
          isActive
            ? 'bg-alba-green-500 text-white'
            : 'text-white/90 hover:bg-alba-blue-700'
        }
      `}
    >
      {Icon && <Icon className='h-4 w-4 flex-shrink-0' strokeWidth={1.6} />}
      <span className='flex-1 overflow-hidden whitespace-nowrap text-left font-medium'>
        {item.label}
      </span>
    </Link>
  );
}
